import { jsx as c } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { B as e } from "./Button-icgr8OM9.js";
const m = i(
  function(o, t) {
    const { icon: n, ...r } = o;
    return /* @__PURE__ */ c(e, { ...r, ref: t, iconOnly: !0, children: n });
  }
);
m.displayName = "IconButton";
export {
  m as I
};
//# sourceMappingURL=IconButton-D1bLZM6I.js.map
